import dayjs from 'dayjs';

export function formatPoints(n: number): string {
  if (n == null || isNaN(n)) return '0';
  return n.toLocaleString('zh-CN');
}

export function formatCNY(n: number): string {
  if (n == null || isNaN(n)) return '¥0.00';
  return `¥${n.toFixed(2)}`;
}

export function formatDate(d: string | Date | null | undefined): string {
  if (!d) return '';
  const date = dayjs(d);
  if (!date.isValid()) return '';
  return date.format('YYYY-MM-DD HH:mm');
}

export function stripPhonePrefix(phone: string | null | undefined): string {
  if (!phone) return '';
  return phone.replace(/^(\+?86)/, '');
}
